import { Address, AddressType } from "@/types";
import AddressTypeEnum from "@/constants/enums/AddressTypeEnum";

const DELIVERY_ADDRESS_PRIORITY: AddressTypeEnum[] = [
  AddressTypeEnum.SHIPPING,
  AddressTypeEnum.VISITING,
  AddressTypeEnum.BILLING,
  AddressTypeEnum.HOME,
];

export function findDeliveryAddressObject(addresses: Address[]): Address | undefined {
  for (const type of DELIVERY_ADDRESS_PRIORITY) {
    const matches = addresses.filter((address) => address.addressType === type);
    if (matches.length > 0) return matches.find((address) => address.isDefault) ?? matches[0];
  }
  return undefined;
}

export function findDeliveryAddress(addresses: Address[]) {
  return formatAddress(findDeliveryAddressObject(addresses));
}

export function formatAddress(address: Address | undefined) {
  if (!address) return undefined;
  return `${address.address}, ${address.postCode} ${address.place}, ${address.country.name}`;
}

export function markAddressAsDefault<T extends { addressType: AddressType; isDefault?: boolean }>(
  addresses: T[],
  target: T
): T[] {
  return addresses.map((addr) => {
    if (addr.addressType !== target.addressType) return addr;
    return { ...addr, isDefault: addr === target };
  });
}
